import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../lib/baseQueries";

export interface IFeedbackPayload {
  email: string;
  text: string;
}

export interface IFeedbackResponse {
  message: string;
  data: {
    id: string;
    userId: string;
    email: string;
    text: string;
    createdAt: string;
  };
}

export const feedbackApi = createApi({
  reducerPath: "feedbackApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    sendFeedback: builder.mutation<IFeedbackResponse, IFeedbackPayload>({
      query: (payload) => ({
        url: "/v1/feedback",
        method: "POST",
        data: payload,
      }),
    }),
  }),
});

export const { useSendFeedbackMutation } = feedbackApi;
